export default {
  COPYRIGHT_LABEL: 'Copyright',
  TWITTER_LABEL: 'Go to Twitter page',
  LINKEDIN_LABEL: 'Go to LinkedIn page',
  NAVIGATE_TO_MY_STATEMENT: 'Navigate to My Statement',
};